<mat-form-field subscriptSizing="dynamic">
  <mat-label>{{ labelKey | translate }}</mat-label>
  <mat-chip-grid #chipGrid [disabled]="disabled">
    @for (threshold of thresholds; track threshold) {
      <mat-chip-row (removed)="remove(threshold)">
        {{ threshold }}%
        <button matChipRemove type="button" [attr.aria-label]="'METRICS.SUBSCRIPTION_USAGE.REMOVE_ALERT' | translate: { threshold: threshold }">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="'METRICS.SUBSCRIPTION_USAGE.ADD_ALERT_PLACEHOLDER' | translate"
      [disabled]="disabled || thresholds.length >= maxCount"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  @if (hintKey !== null) {
    <mat-hint>{{ hintKey | translate }}</mat-hint>
  }
</mat-form-field>
